import { LogState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const mutations = {
  setLogContent(state: LogState, payload: string) {
    state.logString = payload;
  },
};

const { commit } = getStoreAccessors<LogState, State>("");

export const commitSetLogContent = commit(mutations.setLogContent);
